export default __webpack_public_path__ + "static/media/loader-min.52a936fd.gif";